import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePregnancyStore } from '@/store/pregnancyStore';

interface PregnancyOnlyGuardProps {
  children: React.ReactNode;
}

/**
 * PregnancyOnlyGuard - Restricts access to pregnancy-only features.
 *
 * Access is granted ONLY if user has an active pregnancy (not in baby mode).
 * Redirects to dashboard if user is in baby mode or idle mode.
 */
export function PregnancyOnlyGuard({ children }: PregnancyOnlyGuardProps) {
  const { currentPregnancy, appMode } = usePregnancyStore();
  const navigate = useNavigate();

  const hasAccess = currentPregnancy?.is_active && appMode === 'pregnancy';

  useEffect(() => {
    // Redirect to dashboard if not in active pregnancy mode
    if (!hasAccess) {
      navigate('/', { replace: true });
    }
  }, [hasAccess, navigate]);

  // If access is denied, don't render children (redirect will happen)
  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
}
